import { connect } from 'react-redux'
import { selectDraftMailbox } from 'ducks/drafts'
import { selectKnownMailboxes } from 'selectors/mailboxes_base'
import FromRow from './view'

const select = state => ({
  mailboxes: selectKnownMailboxes(state),
  mailbox: selectDraftMailbox(state),
})

export default connect(select, null)(FromRow)
